import { Head, useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { passwords } from '@/routes'

export default function Reset({ token }: { token: string }) {
  const form = useForm({ password: '', password_confirmation: '' })

  return (
    <Card>
      <Head title="Set password" />
      <CardHeader>
        <CardTitle>Choose a password</CardTitle>
      </CardHeader>
      <CardContent>
        <form
          className="grid gap-4"
          onSubmit={(e) => {
            e.preventDefault()
            form.submit(passwords.update(token))
          }}
        >
          <div className="grid gap-2">
            <Label htmlFor="password">New password</Label>
            <Input
              id="password"
              type="password"
              autoComplete="new-password"
              value={form.data.password}
              onChange={(e) => form.setData('password', e.target.value)}
              required
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="password_confirmation">Confirm password</Label>
            <Input
              id="password_confirmation"
              type="password"
              autoComplete="new-password"
              value={form.data.password_confirmation}
              onChange={(e) => form.setData('password_confirmation', e.target.value)}
              required
            />
          </div>
          <Button type="submit" disabled={form.processing}>
            Save password
          </Button>
        </form>
      </CardContent>
    </Card>
  )
}
